import React, { Component } from "react";
import { withFirebase } from "../Firebase";
import {

  Tab,
  Tabs,

} from "@blueprintjs/core";

import { Grid } from "react-flexbox-grid";

import "./index.css";
import Summarization from "./Summarization";
import EventsOnly from "./EventsOnly";



class EventsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      events: [],
      visible_events: [],
      filters: {},
      selectedIndexes: [],
      selectedEvents: [],
      rows: "",
      range: [
        new Date(),
        new Date(new Date().setMonth(new Date().getMonth() + 1))
      ],
      total_registered: 0,
      total_attended: 0,
      total_walkins: 0,
      total_waitlist: 0
    };
  }
  render() {
    return (
      <div className="margin-top">
        <Grid>
          <Tabs id="TabMenu" animate={true} renderActiveTabPanelOnly={true}>
            <Tab
              id="summarization"
              title="Summarization"
              panel={<Summarization />}
            ></Tab>
            <Tab id="eventsOnly" title="Check-In" panel={<EventsOnly />}></Tab>
          </Tabs>
        </Grid>
      </div>
    );
  }
}
export default withFirebase(EventsPage);
